<mat-form-field>
  <mat-select placeholder="AccessList" #select>
    <mat-option>- Keine -</mat-option>
    <mat-option *ngFor="let accesslist of dmsAccessLists" [value]="accesslist">
      {{ accesslist }}
    </mat-option>
  </mat-select>
</mat-form-field>
